<template>
    <v-tooltip 
        content-class="right" 
        right
    >
        <template v-slot:activator="{ on, attrs }">
            <v-list-item
                :ripple="false"
                v-bind="attrs"
                v-on="on"
            >
                <div class="widget-item disabled">
                    <img
                        v-if="widget.icon"
                        class="rounded"
                        :src="widget.icon"
                    >
                    <v-list-item-icon v-else>
                        <v-icon :class="`icon icon-${widget.id}`"/>
                    </v-list-item-icon>

                    <v-list-item-title
                        class="text-none"
                        v-html="widget.text"
                    />
                </div>
            </v-list-item>
        </template>
        <span>
            {{ $t("pwa.offline.disabledWidget") }}
        </span>
    </v-tooltip>
</template>

<script>
    export default {
        name: 'DisabledOfflineWidget',
        props: {
            widget: {
                type: Object,
                required: true
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/layout/sidebar/components/DisabledOfflineWidget.vue